/** Gross job total from the professional's estimate (what the owner pays before Stripe fees). */
export function grossJobAmountFromMaintenanceRequest(job) {
  const pe = job?.profesionalEstimate || job?.professionalEstimate;
  const n = parseFloat(pe?.amount);
  return Number.isFinite(n) ? n : 0;
}

/** Platform fee % for display fallback: pro override, then platform default. */
export function effectiveProfessionalPlatformFeePercent(profData, platformDefaultPct) {
  const o = profData?.platformFeeOverridePercentage;
  if (typeof o === 'number' && Number.isFinite(o)) return Math.min(100, Math.max(0, o));
  if (typeof platformDefaultPct === 'number' && Number.isFinite(platformDefaultPct)) {
    return Math.min(100, Math.max(0, platformDefaultPct));
  }
  return null;
}

/**
 * Net amount the professional receives after the platform application fee.
 * Prefer values written at payment capture; otherwise approximate from gross + fee % (same rounding as Cloud Function).
 */
export function professionalNetPayoutDollars(job, feePercentFallback) {
  const gross = grossJobAmountFromMaintenanceRequest(job);
  const pd = job?.paymentData;

  if (pd && typeof pd.proNetPayoutDollars === 'number' && Number.isFinite(pd.proNetPayoutDollars)) {
    return Math.max(0, pd.proNetPayoutDollars);
  }
  if (
    pd &&
    typeof pd.amount === 'number' &&
    Number.isFinite(pd.amount) &&
    typeof pd.applicationFeeCents === 'number' &&
    Number.isFinite(pd.applicationFeeCents)
  ) {
    return Math.max(0, Math.round(pd.amount * 100 - pd.applicationFeeCents) / 100);
  }
  if (typeof feePercentFallback === 'number' && feePercentFallback > 0 && gross > 0) {
    const cents = Math.round(gross * 100);
    const feeCents = Math.min(cents - 1, Math.round((cents * feePercentFallback) / 100));
    return Math.max(0, (cents - feeCents) / 100);
  }
  return gross;
}
